// extracted by mini-css-extract-plugin
export var imageContainer = "hero-module--image-container--1BwjF";
export var titleContainer = "hero-module--title-container--2s3eB";